import { cn } from '@/shared/utils';
import { Loader2 } from 'lucide-react';

interface Props {
  className?: string;
}

const Loader = ({ className }: Props) => {
  return (
    <div
      className={cn(
        'w-full h-full flex items-center justify-center',
        className
      )}>
      <Loader2 className="size-8 animate-spin" />
    </div>
  );
};

export { Loader };
